function MetabolicSyndromeCalc(gender, Abs, Trigli, HDL, Systolic, Diastolic, Glucose) {

    let high_perimeter = gender === "M" && parseInt(Abs) > 102 ? 1 : gender === "F" && parseInt(Abs) > 88 ? 1 : 0
    let high_trigli = parseInt(Trigli) > 150 ? 1 : 0
    let high_hdl = gender === "M" && parseInt(HDL) < 40 ? 1 : gender === "F" && parseInt(HDL) < 50 ? 1 : 0
    let high_sis = parseInt(Systolic) >= 130 ? 1 : 0
    let high_dia = parseInt(Diastolic) >= 80 ? 1 : 0
    let high_glucose = parseInt(Glucose) >= 100 ? 1 : 0

    let points = high_perimeter + high_trigli + high_hdl + high_sis + high_dia + high_glucose

    let results = {}

    if(points < 2) {
        results["risk"] = 0
        results["riskCat"] = "No Posee Síndrome Metabólico"
    } else if (points < 3) {
        results["risk"] = 1
        results["riskCat"] = "Alteración Metabólica"
    } else {
        results["risk"] = 2
        results["riskCat"] = "Posee Síndrome Metabólico"
    }

    results["points"] = points

    return results;
};

export default MetabolicSyndromeCalc;